import createConversionMap from '@shared/helpers/object-converter';
import { ISCDUser } from '@shared/interfaces';

export interface IUserBaseData {
    company?: string;
    country?: string;
    department?: string;
    departmentText?: string;
    eMail?: string;
    firstName?: string;
    fullName?: string;
    lastName?: string;
    title?: string;
    userLocation?: string;
    gender?: string;
    id?: string;
}

export const scdToUserBaseConversionMap = createConversionMap<ISCDUser, IUserBaseData>()
    .from('firstName')
    .to('firstName')
    .from('lastName')
    .to('lastName')
    .from('eMail')
    .to('eMail')
    .from('department')
    .to('department')
    .from('departmentText')
    .to('departmentText')
    .from('title')
    .to('title')
    .from('fullName')
    .to('fullName')
    .from('userLocation')
    .to('userLocation')
    .from('country')
    .to('country')
    .from('company')
    .to('company')
    .from('gender')
    .to('gender')
    .from('fullName')
    .to('fullName');

export const scdToUserBaseConverter = {
    toApi: scdToUserBaseConversionMap.build(),
    toApiMulti: scdToUserBaseConversionMap.buildMulti()
};
